import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionTitle = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const SectionValue = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
`;

export const FooterNote = styled.p`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
  margin: 0;
`;
